import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material'
import { ResponseSetExcelOutputSettingEnum } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import FormikErrorMessage from 'src/components/formikErrorMessage/FormikErrorMessage'
import { useLimitedFeatureAvailability } from 'src/features/featureAvailability/useLimitedFeatureAvailability'
import { useFormikProps } from './EditMultipleChoiceSet.hooks'

const ExcelConversionSettingsRow: FC = () => {
  const {
    formikProps: { setFieldValue, values, errors, touched },
  } = useFormikProps()

  const { isFeatureAvailable } = useLimitedFeatureAvailability()

  return isFeatureAvailable('excelConversionEdit') ? (
    <Stack spacing={1} alignItems="flex-start">
      <Typography variant="subtitle1">Excel変換設定</Typography>
      <RadioGroup
        onChange={e =>
          setFieldValue('excelOutputOption', Number(e.target.value))
        }
        value={String(values.excelOutputOption ?? '')}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <FormControlLabel
            value={String(ResponseSetExcelOutputSettingEnum.DiscriminationKey)}
            control={<Radio />}
            label="「判別キー」をExcel変換時使用する"
          />
          <FormControlLabel
            value={String(ResponseSetExcelOutputSettingEnum.Name)}
            control={<Radio />}
            label="「選択肢名」をExcel変換時使用する"
          />
        </Stack>
      </RadioGroup>
      <FormikErrorMessage
        name="excelOutputOption"
        errors={errors}
        touched={touched}
      />
    </Stack>
  ) : null
}

export default ExcelConversionSettingsRow
